<plan-banner
  *ngIf="environment.hasPlanSelection && !isPlanSelection"
  [activePlan$]="service.activePlan$"
  (togglePlanSelection)="onPlanBannerClick()"
></plan-banner>

<article-search-form
  [showForm]="!environment.hasPlanSelection || !isPlanSelection"
/>
<plan-selection
  *ngIf="environment.hasPlanSelection && isPlanSelection; else homepage"
  [allPlans$]="service.allPlans$"
  [activePlan$]="service.activePlan$"
  [selectedAssistance$]="service.assistance$"
  [loadingStatus$]="service.loadingStatus$"
  (selectPlan)="onSelectPlan($event)"
  (selectAssistance)="selectAssistance($event)"
  (togglePlanSelection)="confirmPlanSelection()"
></plan-selection>

<ng-template #homepage>
  <homepage
    [applianceCategoriesTitle$]="service.applianceCategoriesTitle$"
    [applianceCategories$]="service.applianceCategories$"
    [popularVideosBlock$]="service.popularVideosBlock$"
    (categoryClick)="onClick($event)"
  ></homepage>
</ng-template>
